module.exports = __webpack_public_path__ + "08_mole.5475acd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer2/08_mole.png
// module id = wZXQ
// module chunks = 0